import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { Field } from 'redux-form';
import ticketsCheckedColumns from '@modules/tickets/_ticketsColumns';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                name={'employeeId'}
                id={'employeeId'}
                label={'Strážník'}
                fullWidth={true}
                url="/metropolis/api/hr/employees"
                labelFunction={o => get(o, 'fullName')}
                valueFunction={o => get(o, 'id')}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <Field
                component={InlineGrid}
                adding={false}
                filtering={false}
                name="checkedItems"
                columns={ticketsCheckedColumns}
                style={{ height: '50vh', overflow: 'auto' }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
    <Divider />
  </div>
);

export const TicketsMoveFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsMoveFormBasic.tsx